const configSet = {
    livingTime: {
        listLayout: "SetLivingTimeLayout",
        filterLayout: "SetFilterDefaultLayout",
        paginationLayout: "PaginationDefaultLayout",
        getFunc: "getTimeZone",
        paginationType: "lazyload",
        listApiParamSet: {
            ip : 1
        },
        pageRow: 10,
    },
    livingCountry: {
        listLayout: "SetLivingCountryLayout",
        filterLayout: "SetFilterDefaultLayout",
        paginationLayout: "PaginationDefaultLayout",
        getFunc: "getCountry",
        paginationType: "lazyload",
        listApiParamSet: {
            ip : 1
        },
        pageRow: 10,
    },
    nationality: {
        listLayout: "SetNationalityLayout",
        filterLayout: "SetFilterDefaultLayout",
        paginationLayout: "PaginationDefaultLayout",
        getFunc: "getCountry",
        paginationType: "lazyload",
        listApiParamSet: {
            ip : 1
        },
        pageRow: 10,
    },
    learningLanguage: {
        listLayout: "SetLearningLanguageLayout",
        filterLayout: "SetFilterDefaultLayout",
        paginationLayout: "PaginationDefaultLayout",
        getFunc: "getLanguage",
        paginationType: "lazyload",
        listApiParamSet: {
            ip : 1
        },
        pageRow: 10,
    },
    speakingLanguage: {
        listLayout: "SetSpeakingLanguageLayout",
        filterLayout: "SetFilterDefaultLayout",
        paginationLayout: "PaginationDefaultLayout",
        getFunc: "getLanguage",
        paginationType: "lazyload",
        listApiParamSet: {
            ip : 1
        },
        pageRow: 10,
    },
    gender: {
        listLayout: "SetGenderLayout",
        filterLayout: "",
        paginationLayout: "",
        getFunc: "getLanguage",
        paginationType: "lazyload",
        listApiParamSet: {
            ip : 1
        },
        pageRow: 10,
    }
}

export default {
    methods: {
        returnSetConfig(type) {
            return configSet[type];
        }
    },
    filterConfig: {
        cr: {
            type: 'between',
            classname: 'filterDate'
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        pgnu: {
            type: 'query',
            classname: 'searchInput',
        },
        oid: {
            type: 'query',
            classname: 'searchInput',
        },
        st:{
            type:'match',
            classname:'filterStatus'
        },
        pg:{
            type:'match',
            classname:'filterPayType'
        },
        cid: {
            type: 'match',
            classname: 'langOption'
        },
    }
}
